import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { DirectivesModule } from '../../directives.module';
import { DriverDetailsRecordComponent } from './driver-details-record.component';
import { OrderStatusViewComponent } from './order-status-view/order-status-view.component';

@NgModule({
  declarations: [
    DriverDetailsRecordComponent,
    OrderStatusViewComponent,
  ],
  imports: [
    CommonModule,
    MatCheckboxModule,
    MatButtonModule,
    MatIconModule,
    DirectivesModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
  ],
  exports: [
    DriverDetailsRecordComponent,
  ],
})
export class DriverDetailsRecordModule { }
